exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".StandardWidthPage-9cf93d69{width:100%;padding-left:15px;padding-right:15px;margin-left:auto;margin-right:auto;max-width:1030px;width:80vw;position:relative}@media screen and (max-width: 1000px){.StandardWidthPage-9cf93d69{width:100%}}\n", ""]);

// Exports
exports.locals = {
	"StandardWidthPage": "StandardWidthPage-9cf93d69"
};